import { createActionNamespace } from 'edp-redux-tools';

const { addActions } = createActionNamespace('[resources/test proctoring]');

export default addActions({
  LOAD_STATUS: [],
  LOAD_STATUS_SUCCESS: ['payload'],
  LOAD_STATUS_FAILURE: [],

  LOAD_STATUS_UPDATE: [],
  LOAD_STATUS_UPDATE_SUCCESS: ['payload'],

  LOAD_STATUS_BY_TEST_SECTIONS: ['testId', 'sectionIds'],
  LOAD_STATUS_BY_TEST_SECTIONS_SUCCESS: ['payload'],
  LOAD_STATUS_BY_TEST_SECTIONS_FAILURE: [],

  LOAD_TEST_ENTRIES_BY_SECTION_AND_TEST: ['testAndSectionIds'],
  LOAD_TEST_ENTRIES_BY_SECTION_AND_TEST_SUCCESS: ['payload'],
  LOAD_TEST_ENTRIES_BY_SECTION_AND_TEST_FAILURE: [],

  UPDATE_AVAILABILITY_FOR_TEST_SECTION: ['testId', 'sectionId', 'isAvailable'],
  UPDATE_AVAILABILITY_FOR_TEST_SECTION_SUCCESS: ['sectionId', 'testId', 'testEntries'],
  UPDATE_AVAILABILITY_FOR_TEST_SECTION_FAILURE: ['sectionId', 'testId'],

  UPDATE_INCLUDED_STUDENT_FOR_TEST_PROCTORING: [
    'sectionId',
    'testId',
    'studentId',
    'included'
  ],
  UPDATE_INCLUDED_STUDENT_FOR_TEST_PROCTORING_SUCCESS: [
    'sectionId',
    'testId',
    'studentId',
    'included',
    'includedStudents'
  ],
  UPDATE_INCLUDED_STUDENT_FOR_TEST_PROCTORING_FAILURE: ['sectionId', 'testId', 'studentId'],

  UPDATE_INCLUDED_ALL_STUDENTS_FOR_TEST_PROCTORING: ['sectionId', 'testId', 'included'],
  UPDATE_INCLUDED_ALL_STUDENTS_FOR_TEST_PROCTORING_SUCCESS: [
    'sectionId',
    'testId',
    'included',
    'includedStudents'
  ],
  UPDATE_INCLUDED_ALL_STUDENTS_FOR_TEST_PROCTORING_FAILURE: ['sectionId', 'testId'],

  REOPEN_TEST_ENTRY: ['testEntryId'],
  REOPEN_TEST_ENTRY_SUCCESS: ['testEntryId', 'testEntries'],
  REOPEN_TEST_ENTRY_FAILURE: ['testEntryId'],

  FORCE_SUBMIT_TEST_ENTRY: ['testEntryId'],
  FORCE_SUBMIT_TEST_ENTRY_SUCCESS: ['testEntryId', 'testEntries'],
  FORCE_SUBMIT_TEST_ENTRY_FAILURE: ['testEntryId'],

  UPDATE_STUDENT_SUPPORTS: ['id', 'supports'],
  UPDATE_STUDENT_SUPPORTS_SUCCESS: ['entry']
});
